import * as React from "react"
import CustomModal from "components/Modals/CustomModal"

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  shouldGuard: boolean
  children: React.ReactNode
}

export function GuardedAnchor({ shouldGuard, href, children, ...props } : Props) {
  const [modal, setModal] = React.useState<"confirm-leave" | null>(null)
  const [pendingHref, setPendingHref] = React.useState<string | undefined>()

  const handleClick = (e) => {
    if (!shouldGuard) return
    e.preventDefault()
    setModal("confirm-leave")
    setPendingHref(href)
  }

  return (
    <>
      <a href={href} onClick={handleClick} {...props}>{children}</a>
      <CustomModal
            showModal={modal === "confirm-leave"}
            header="Confirm leaving the assignment"
            body="Are you sure that you want to leave the assignment?"
            onConfirm={() => {
                if (pendingHref) {
                    window.location.href = pendingHref
                }
            }}
            onDecline={() => setModal(null)}
            confirmBtn={{text: "Yes", color: "secondary"}}
            declineBtn={{text: "No", color: "theme"}}
        />
    </>
  )
}
